import SlotsGrid from '@/core/SlotsGrid'

export const user = (state) => {
    return state.user
}

/**
 * @returns {SlotsGrid}
 */
export function slotsGrid (state) {
    return state.slotsGrid
}
